import { render, staticRenderFns } from "./InternalFile.vue?vue&type=template&id=641f8f88&scoped=true"
import script from "./InternalFile.vue?vue&type=script&lang=js"
export * from "./InternalFile.vue?vue&type=script&lang=js"
import style0 from "./InternalFile.vue?vue&type=style&index=0&id=641f8f88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641f8f88",
  null
  
)

export default component.exports